if (!customElements.get('vv-sticky-scroll')) {
  customElements.define('vv-sticky-scroll', class extends HTMLElement {
    connectedCallback() {
      this.videos = Array.from(this.querySelectorAll('[data-story-video]'));
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-video-toggle]');
        if (!button) return;
        const video = button.parentElement.querySelector('video');
        video.dataset.userPaused = String(!video.paused);
        if (video.paused) this.playVideo(video);
        else video.pause();
      }, options);
      this.videoObserver = new IntersectionObserver((entries) => {
        entries.forEach(({ target: video, isIntersecting }) => {
          video.dataset.visible = String(isIntersecting);
          if (isIntersecting && !this.motion.matches && video.dataset.userPaused !== 'true' && !document.hidden) this.playVideo(video);
          else video.pause();
        });
      }, { threshold: 0.35 });
      this.videos.forEach((video) => {
        const button = video.parentElement.querySelector('[data-video-toggle]');
        const updateButton = () => {
          button.textContent = video.paused ? `${button.dataset.playLabel} ▶` : `${button.dataset.pauseLabel} Ⅱ`;
          button.setAttribute('aria-label', video.paused ? button.dataset.playAria : button.dataset.pauseAria);
        };
        video.addEventListener('play', updateButton, options);
        video.addEventListener('pause', updateButton, options);
        this.videoObserver.observe(video);
      });
      document.addEventListener('visibilitychange', () => {
        this.videos.forEach((video) => {
          if (document.hidden) video.pause();
          else if (video.dataset.visible === 'true' && !this.motion.matches && video.dataset.userPaused !== 'true') this.playVideo(video);
        });
      }, options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.videos.forEach((video) => video.pause());
      }, options);

    }

    playVideo(video) {
      if (!video.getAttribute('src')) video.src = video.dataset.src;
      video.play().catch(() => {});
    }

    disconnectedCallback() {
      this.events?.abort();
      this.videoObserver?.disconnect();
      this.videos?.forEach((video) => video.pause());
    }
  });
}
